import React, { useEffect, useState } from 'react';
import { Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-hot-toast';
import { useSelector } from 'react-redux';
import { postApi } from '../../api';
import Button from '../ui/Button';

const SignupSchema = Yup.object().shape({
	email: Yup.string().email('Invalid email'),
	password: Yup.string().required('New Password is required!'),
	confirmPassword: Yup.string()
		.required('Confirm Password is required!')
		.oneOf(
			[Yup.ref('password'), null],
			'Password and confirm password must match'
		),
});

const UpdatePassword = () => {
	const { user } = useSelector((state) => state.user);
	const [isLoading, setIsLoading] = useState(false);
	const handleSubmit = async (values) => {
		setIsLoading(true);
		postApi(`system/users/${user?.user?.uuid}/update-password/`, {
				password: values.password,
			})
			.then(() => {
				setIsLoading(false);
				toast.success('Password updated successfully');
			})
			.catch((error) => {
				setIsLoading(false);
				toast.error(error?.error || error?.message || 'Password update failed');
			});
	};

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	return (
		<div className="max-w-screen-2xl">
			<div className="md:grid md:grid-cols-3 md:gap-6">
				<div className="md:col-span-1">
					<div className="px-4 sm:px-0">
						<h2 className="text-xl font-semibold mb-5 text-black">
							Change Password
						</h2>
					</div>
				</div>
			</div>

			<Formik
				initialValues={{
					password: '',
					confirmPassword: '',
					email: user?.user?.email,
				}}
				validationSchema={SignupSchema}
				onSubmit={handleSubmit}
			>
				{({ errors, touched }) => {
					return (
						<Form>
							<div className="md:grid-cols-6 md:gap-6">
								<div className=" md:mt-0 md:col-span-2">
									<div className="lg:mt-6bg-white">
										<div className="grid grid-cols-6 gap-6">
											<div className="col-span-6 sm:col-span-6">
												<label
													htmlFor="email"
													className="block text-gray-500 font-medium text-sm leading-none mb-2"
												>
													Email Address
												</label>
												<div className="relative">
													<Field
														id="email"
														name="email"
														placeholder="Your Email"
														className="py-2 px-4 md:px-5 w-full appearance-none border text-sm opacity-75 text-input rounded-md placeholder-body min-h-12 transition duration-200 focus:ring-0 ease-in-out bg-white border-gray-200 focus:outline-none focus:border-brand-500 h-11 md:h-12"
													/>
												</div>
												<span className="text-red-400 text-sm mt-2">
													{errors.email && touched.email && (
														<div>{errors.email}</div>
													)}
												</span>
											</div>
											<div className="col-span-6 sm:col-span-6">
												<label
													htmlFor="password"
													className="block text-gray-500 font-medium text-sm leading-none mb-2"
												>
													New Password
												</label>
												<div className="relative">
													<Field
														id="password"
														name="password"
														placeholder="Your New Password"
														className="py-2 px-4 md:px-5 w-full appearance-none border text-sm opacity-75 text-input rounded-md placeholder-body min-h-12 transition duration-200 focus:ring-0 ease-in-out bg-white border-gray-200 focus:outline-none focus:border-brand-500 h-11 md:h-12"
													/>
												</div>
												<span className="text-red-400 text-sm mt-2">
													{errors.password && touched.password && (
														<div>{errors.password}</div>
													)}
												</span>
											</div>
											<div className="col-span-6 sm:col-span-6">
												<label
													htmlFor="confirmPassword"
													className="block text-gray-500 font-medium text-sm leading-none mb-2"
												>
													Confirm Password
												</label>
												<div className="relative">
													<Field
														id="confirmPassword"
														name="confirmPassword"
														placeholder="Confirm your Password"
														className="py-2 px-4 md:px-5 w-full appearance-none border text-sm opacity-75 text-input rounded-md placeholder-body min-h-12 transition duration-200 focus:ring-0 ease-in-out bg-white border-gray-200 focus:outline-none focus:border-brand-500 h-11 md:h-12"
													/>
												</div>
												<span className="text-red-400 text-sm mt-2">
													{errors.confirmPassword &&
														touched.confirmPassword && (
															<div>{errors.confirmPassword}</div>
														)}
												</span>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="mt-5 text-right">
								<Button type="submit" size="lg" disabled={isLoading} className="mt-1 w-full sm:w-auto">
									{!isLoading ? 'Change Password' : 'Updating'}
								</Button>
							</div>
						</Form>
					);
				}}
			</Formik>
		</div>
	);
};

export default UpdatePassword;
